import React from "react";
import { List, Tag, Typography, Empty } from "antd";
import { BellOutlined } from "@ant-design/icons";
import WidgetWrapper from "../../components/WidgetWrapper";
import { useLoadList } from "../../../../hooks";
import { flightOperationFlightService } from "../../../../api/enhancedApi";
import dayjs from "dayjs";

const { Text } = Typography;

const OpsAlertWidget = () => {
    const { data, isLoading, refetch } = useLoadList("ops_alert_widget", flightOperationFlightService.getFlightOperations, {
        page: 1,
        page_size: 20,
        start_date: dayjs().subtract(1, "day").format("YYYY-MM-DD"), // Recent flights
        sort_by: "updated_at",
        sort_order: "desc",
    });

    const flightsWithNotes = data?.items?.filter((f) => f.latest_occ_note_remarks) || [];

    return (
        <WidgetWrapper title="运行通告 (OCC Notes)" loading={isLoading} onRefresh={refetch}>
            {flightsWithNotes.length > 0 ? (
                <List
                    dataSource={flightsWithNotes}
                    renderItem={(item) => (
                        <List.Item>
                            <List.Item.Meta
                                avatar={<BellOutlined style={{ color: "var(--status-warning)" }} />}
                                title={
                                    <span>
                                        {item.flight_number}{" "}
                                        <Text type="secondary" style={{ fontSize: "12px", color: "var(--text-secondary)" }}>
                                            {dayjs(item.std).format("MM-DD")}
                                        </Text>
                                    </span>
                                }
                                description={
                                    <div>
                                        <Tag color={item.status === "DELAYED" ? "red" : "default"}>{item.status}</Tag>
                                        <Text style={{ color: "var(--text-primary)" }}>{item.latest_occ_note_remarks}</Text>
                                    </div>
                                }
                            />
                        </List.Item>
                    )}
                />
            ) : (
                <Empty description="暂无运行通告" image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
        </WidgetWrapper>
    );
};

export default OpsAlertWidget;
